import React, {FC, useCallback, useRef, useState} from 'react';
import ReactAudioPlayer from 'react-audio-player';

import './styles.scss';
import playIcon from 'assets/svg/match_header_play.svg';

const LiveBroadcastPlayer: FC = () => {
  const [canPlay, setCanPlay] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const player = useRef<ReactAudioPlayer>(null);

  const togglePlay = useCallback(() => {
    if (player.current && player.current.audioEl.current) {
      if (isPlaying) {
        setIsPlaying(false);
        player.current.audioEl.current.pause();
      } else {
        setIsPlaying(true);
        player.current.audioEl.current.play();
      }
    }
  }, [isPlaying]);

  return (
    <button
      type="button"
      className={`LiveBroadcastPlayer ${isPlaying ? 'LiveBroadcastPlayer--is-playing' : ''} ${
        !canPlay ? 'LiveBroadcastPlayer--hidden' : ''
      }`}
      onClick={() => togglePlay()}
    >
      <img className="LiveBroadcastPlayer__icon" src={playIcon} alt="play" />
      <span className="LiveBroadcastPlayer__label">ΖΩΝΤΑΝΗ ΜΕΤΑΔΟΣΗ</span>
      <ReactAudioPlayer
        ref={player}
        src={process.env.REACT_APP_LIVE_BROADCAST_URL}
        onCanPlay={() => setCanPlay(true)}
        onError={() => setCanPlay(false)}
      />
    </button>
  );
};

export default LiveBroadcastPlayer;
